/**
 * Workaround for the Nova / baCurr currency selector losing the shopper's choice.
 *
 * The app converts the prices and updates the selector label when a currency is picked,
 * but never writes the choice into `baCurr.config`. Its own `window.onresize` handler
 * calls `baCurr.repeat()`, which detaches the selector and rebuilds it from that stale
 * config — so the label snaps back to the store default while the prices stay converted.
 *
 * On iOS Safari every scroll that shows/hides the address bar fires `resize`, which is
 * why shoppers on mobile see the header currency revert as soon as they scroll.
 *
 * Fix: note the currency on the label before the app rebuilds the selector, and put it
 * back afterwards.
 *
 * Only the label is rewritten. Feeding the choice into `baCurr.config` around the
 * re-render also works, but it poisons the app's per-currency price cache: a shopper who
 * then switches to a third currency gets the previous currency's amounts under the new
 * symbol. The prices are already correct on their own — the label is the only thing that
 * needs help.
 *
 * Requires currency-selection-state.js. Remove both once the app persists the selection.
 */
(function () {
  var LABEL = '.bacurr-choiceDesign';
  var CHOSEN = '.ba-chosen';
  var FLAG = '.baCountry';

  function restoreLabel(code) {
    document.querySelectorAll(LABEL).forEach(function (label) {
      var chosen = label.querySelector(CHOSEN);
      if (chosen && chosen.textContent.trim() !== code) chosen.textContent = code;

      // The flag icon is a `baCountry-<CODE>` modifier class on its own element.
      var flag = label.querySelector(FLAG);
      if (!flag) return;
      var expected = 'baCountry-' + code;
      if (flag.classList.contains(expected)) return;
      Array.from(flag.classList).forEach(function (name) {
        if (/^baCountry-[A-Z]{3}$/.test(name)) flag.classList.remove(name);
      });
      flag.classList.add(expected);
    });
  }

  function patch() {
    if (!window.DefactoCurrency || !window.baCurr || typeof window.baCurr.repeat !== 'function') return false;

    var originalRepeat = window.baCurr.repeat;

    window.baCurr.repeat = function () {
      // Read before the re-render: afterwards the label is back on the store default.
      var code = window.DefactoCurrency.selected();
      var result = originalRepeat.apply(this, arguments);
      if (code) restoreLabel(code);
      return result;
    };

    return true;
  }

  // `baCurr` is injected asynchronously by the app embed, so wait for it before patching.
  if (!patch()) {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (patch() || attempts > 40) clearInterval(timer);
    }, 250);
  }
})();
